/**
 * Privacy-first link chips — SPEC link previews.
 * Default: parse URL + show hostname only. Never fetch remote page content
 * (no tracker pixels / no third-party scripts).
 */

const URL_RE = /\bhttps?:\/\/[^\s<>"'`]+/gi;

export interface LocalLinkChip {
  url: string;
  hostname: string;
  start: number;
  end: number;
}

export function extractUrls(text: string): LocalLinkChip[] {
  const out: LocalLinkChip[] = [];
  const re = new RegExp(URL_RE.source, "gi");
  let m: RegExpExecArray | null;
  while ((m = re.exec(text))) {
    let raw = m[0];
    // trim trailing punctuation commonly glued to URLs
    raw = raw.replace(/[),.!?;:]+$/g, "");
    try {
      const u = new URL(raw);
      if (u.protocol !== "http:" && u.protocol !== "https:") continue;
      out.push({
        url: u.href,
        hostname: u.hostname,
        start: m.index,
        end: m.index + raw.length,
      });
    } catch {
      /* ignore invalid */
    }
  }
  return out;
}

export function linkPreviewLabel(chip: LocalLinkChip): string {
  return `🔗 ${chip.hostname}`;
}
